import React, { useState, useEffect } from "react";
import { useStyles } from "@webapps/styles";
import axios from "axios";
import CalendarContainer from "./CalendarContainer";
import { useCalendar } from "../Stores/CalendarProvider";
import { css } from "@emotion/css";

const NX_REST_API = process.env.NX_REST_API;

const PlanningProfilSidebar = ({ classroomId }) => {
  const {
    classes,
    theme: { spacing },
  } = useStyles(styles);
  const { state, dispatch } = useCalendar();

  const [planning, setPlanning] = useState(null);
  const [periods, setPeriods] = useState([]);
  const [holidays, setHolidays] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    if (classroomId) {
      fetchPlanning();
      getClassDates();
      fetchHolidays();
    }
  }, [classroomId]);

  const fetchPlanning = async () => {
    try {
      const response = await axios.get(
        `${NX_REST_API}/schools/module/classrooms/${classroomId}/planning`
      );
      setPlanning(response.data);
      setPeriods(response.data.periods || []);
    } catch (error) {
      console.error("Error fetching planning:", error);
    }
  };

  const fetchHolidays = async () => {
    try {
      const response = await axios.get(`${NX_REST_API}/schools/module/planning/holiday`);
      setHolidays(response.data);
    } catch (error) {
      console.error("Error fetching holidays:", error);
    }
  };

  const getClassDates = async () => {
    try {
      const response = await axios.get(
        `${NX_REST_API}/schools/module/classrooms/${classroomId}/dates`
      );
      setStartDate(response.data.startDate);
      setEndDate(response.data.endDate);
    } catch (error) {
      console.error("Error fetching class dates:", error);
    }
  };

  const getMonthsBetweenDates = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const months = [];
    while (start <= end) {
      months.push(new Date(start));
      start.setMonth(start.getMonth() + 1);
      start.setDate(1);
    }
    return months;
  };

  const months = startDate && endDate ? getMonthsBetweenDates(startDate, endDate) : [];

  return (
    <div className={classes.container}>
      {months.length > 0 && (
        <CalendarContainer
          months={months}
          periods={periods}
          holidays={holidays}
          startDate={startDate}
          endDate={endDate}
          isHoliday={(day) => holidays.some(h => new Date(h.date).toDateString() === day.toDateString())}
          getPeriodTypeForDay={(day) => periods.find(p => new Date(p.startDate) <= day && new Date(p.endDate) >= day)}
          isClassAuthorized={false}
          from="student"
          containerStyle={
            css({
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              padding: "0px !important"
            })
          }
          calendarStyle={
            css({
              // width: "100%",
              // maxWidth: "300px",
              width: "300px",
              padding: "0px !important"
            })
          }
        />
      )}
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    // backgroundColor: "white",
    // padding: "20px",
    // borderRadius: "10px",

  },
});

export default PlanningProfilSidebar;
